import React from 'react'

function GalleryBred() {
    return (
        <>
            <section className="bredcrumb_section gallery_banner">
                <div className="container">
                    <div className="section_title text-center" data-aos="fade-up" data-aos-duration={1500} >
                        <span className="sub_text">Our glimpsis</span>
                        <h2>restaurant gallery</h2>
                    </div>
                </div>
            </section>
        </>
    )
}

export default GalleryBred